<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>

            <!-- Overlay de carga -->
            <v-overlay :value="overlay" z-index="999">
                <div class="align-center justify-center text-center">
                    <v-progress-circular indeterminate :size="100" :width="7" color="#2DB9D1">
                        <v-img src="/static/icon/favicon.ico" :width="60"></v-img>
                    </v-progress-circular>
                    <p class="mt-5">{{ fraseOverlay }}</p>
                </div>
            </v-overlay>

            <!-- Encabezado -->
            <v-row class="pa-0 mt-0 mb-0">
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="pa-0">
                    <div style="display: flex; width:100%; height:100%; justify-content: flex-start;">
                        <hr class="vr" />
                        <p class="tblName pb-2">Emisiones</p>
                    </div>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="pa-0 d-flex justify-end align-center">
                    <v-btn elevation="0" class="btnNormal mr-2" @click="descargarIMSS()">
                        Descargar IMSS
                    </v-btn>
                    <BtnAcciones :btnNombre="'Acciones'" :btnColor="'color-58C5D8'" class="ml-2">
                        <template v-slot:opciones>
                            <div
                                class="btnAccionesItem py-2"
                                style="cursor:pointer;"
                                @click="abrirDescargaMasiva()"
                            >
                                <span>Descarga masiva</span>
                            </div>
                            <!-- <div
                                class="btnAccionesItem py-2"
                                :class="!registro_patronal_value ? 'deshabilitado' : ''"
                                :style="!registro_patronal_value ? 'cursor:not-allowed;' : 'cursor:pointer;'"
                                @click="registro_patronal_value ? abrirInicializarPeriodos() : null"
                            >
                                <span>Inicializar periodos</span>
                            </div> -->
                        </template>
                    </BtnAcciones>
                    <v-btn height="40" width="40" fab color="#FFFFFF" class="elevation-0 mt-0 ml-2" @click="refresh()">
                        <v-icon color="#96999A">refresh</v-icon>
                    </v-btn>
                </v-col>
            </v-row>

            <!-- Tarjeta principal -->
            <v-row class="mt-6">
                <v-col cols="12" xs="12" sm="12" md="12" class="div-card py-8">

                    <!-- Selector de cliente (solo root) -->
                    <v-row  class="py-0 my-0 mx-2">
                        <v-col v-if="rol == 'root'" cols="12" xs="12" sm="12" md="4" class="py-0">
                            <v-autocomplete
                                outlined
                                :items="clientes"
                                item-text="nombre"
                                item-value="id"
                                label="Cliente"
                                persistent-hint
                                v-model="cliente_value"
                                no-data-text="Datos no disponibles"
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="4" class="py-0">
                            <v-autocomplete
                                outlined
                                :items="itemsRegistrosPatronales"
                                item-text="nombreClave"
                                item-value="id"
                                label="Registro patronal"
                                persistent-hint
                                v-model="registro_patronal_value"
                                clearable
                                no-data-text="Datos no disponibles"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="2" class="py-1">
                            <v-btn
                                elevation="0"
                                class="btnNormalClaro"
                                :disabled="!registro_patronal_value"
                                @click="cargarDatos()"
                            >
                                Obtener datos
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-divider class="mx-6 mb-4"></v-divider>

                    <!-- Cargando -->
                    <div v-if="isLoading" class="d-flex justify-center align-center my-10">
                        <v-progress-circular indeterminate color="#2DB9D1" :size="50"></v-progress-circular>
                    </div>

                    <!-- Sin elementos -->
                    <div
                        v-else-if="items.length === 0"
                        class="d-flex justify-center align-center text-center text-no-elementos my-10"
                    >
                        No hay elementos para mostrar
                    </div>

                    <!-- Tabla -->
                    <template v-else>
                        <div class="table-wrapper mx-2">
                            <table class="emisiones-table">
                                <thead>
                                    <tr>
                                        <th class="th-check">
                                            <v-checkbox
                                                v-model="checkAll"
                                                :indeterminate="selected_general.length > 0 && selected_general.length < items.length"
                                                primary
                                                hide-details
                                                class="my-0"
                                                color="#444975"
                                                @change="toggleSelectAll"
                                            ></v-checkbox>
                                        </th>
                                        <th>Período</th>
                                        <th class="th-center">EMA</th>
                                        <th class="th-center">EBA</th>
                                        <th class="th-center">EMA - EBA</th>
                                        <th class="th-right">Cuota mensual</th>
                                        <th class="th-right">Cuota bimestral</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="item in paginatedItems"
                                        :key="`${item.registro_patronal_id}-${item.periodo}`"
                                        :class="estaSeleccionado(item) ? 'row-selected' : ''"
                                    >
                                        <td class="td-check">
                                            <v-checkbox
                                                v-model="selected_general"
                                                :value="claveUnica(item)"
                                                primary
                                                hide-details
                                                class="my-0"
                                                color="#444975"
                                            ></v-checkbox>
                                        </td>
                                        <td class="td-periodo">{{ periodoMesAnio(item.periodo) }}</td>
                                        <!-- EMA -->
                                        <td class="td-center">
                                            <span
                                                :class="item.url_ema_visor ? 'link-activo' : 'link-inactivo'"
                                                @click="item.url_ema_visor ? descargarArchivo(item, 'ema_visor') : null"
                                            >Visor</span>
                                            <span class="link-sep">|</span>
                                            <span
                                                :class="item.url_ema_sua ? 'link-activo' : 'link-inactivo'"
                                                @click="item.url_ema_sua ? descargarArchivo(item, 'ema_sua') : null"
                                            >SUA</span>
                                            <span class="link-sep">|</span>
                                            <span
                                                :class="item.url_ema_pdf ? 'link-activo' : 'link-inactivo'"
                                                @click="item.url_ema_pdf ? descargarArchivo(item, 'ema_pdf') : null"
                                            >PDF</span>
                                        </td>
                                        <!-- EBA -->
                                        <td class="td-center">
                                            <template v-if="item.tiene_eba">
                                                <span
                                                    :class="item.url_eba_visor ? 'link-activo' : 'link-inactivo'"
                                                    @click="item.url_eba_visor ? descargarArchivo(item, 'eba_visor') : null"
                                                >Visor</span>
                                                <span class="link-sep">|</span>
                                                <span
                                                    :class="item.url_eba_sua ? 'link-activo' : 'link-inactivo'"
                                                    @click="item.url_eba_sua ? descargarArchivo(item, 'eba_sua') : null"
                                                >SUA</span>
                                                <span class="link-sep">|</span>
                                                <span
                                                    :class="item.url_eba_pdf ? 'link-activo' : 'link-inactivo'"
                                                    @click="item.url_eba_pdf ? descargarArchivo(item, 'eba_pdf') : null"
                                                >PDF</span>
                                            </template>
                                            <span v-else class="link-inactivo">—</span>
                                        </td>
                                        <!-- EMA - EBA (Excel) -->
                                        <td class="td-center">
                                            <span
                                                :class="item.url_excel ? 'link-excel' : 'link-inactivo'"
                                                @click="item.url_excel ? descargarArchivo(item, 'excel') : null"
                                            >EXCEL</span>
                                        </td>
                                        <td class="td-right">{{ formatMoney(item.cuota_mensual) }}</td>
                                        <td class="td-right">{{ formatMoney(item.cuota_bimestral) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Paginación -->
                        <div class="pagination-row d-flex justify-end align-center mt-4 mb-2 px-6">
                            <span class="pagination-label mr-2">Mostrar:</span>
                            <v-select
                                v-model="perPage"
                                :items="perPageOptions"
                                dense
                                outlined
                                hide-details
                                class="per-page-select mr-4"
                                @change="currentPage = 1"
                            ></v-select>
                            <span class="pagination-range mr-2">{{ rangoActual }}</span>
                            <v-btn icon small :disabled="currentPage === 1" @click="currentPage--">
                                <v-icon small color="#444975">mdi-chevron-left</v-icon>
                            </v-btn>
                            <template v-for="(page, idx) in paginasBotones">
                                <span
                                    v-if="page === '...'"
                                    :key="`ellipsis-${idx}`"
                                    class="pagination-ellipsis"
                                >...</span>
                                <v-btn
                                    v-else
                                    :key="`page-${page}`"
                                    icon
                                    small
                                    class="pagination-page-btn"
                                    :class="page === currentPage ? 'pagination-btn-active' : 'pagination-btn'"
                                    @click="currentPage = page"
                                >{{ page }}</v-btn>
                            </template>
                            <v-btn icon small :disabled="currentPage === totalPages" @click="currentPage++">
                                <v-icon small color="#444975">mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </template>

                </v-col>
            </v-row>
        </v-container>

        <!-- Modal: Resultados de descarga IMSS -->
        <v-dialog v-model="dialogResultados" max-width="700px" persistent>
            <v-card>
                <v-card-title class="d-flex justify-space-between align-center">
                    <span class="text-h6">Resultados de descarga IMSS</span>
                    <v-btn icon @click="dialogResultados = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <p v-if="resultadosProcesados.length > 0" class="mb-2" style="color:#2DB9D1; font-weight:600;">
                        <v-icon color="#2DB9D1" class="mr-1">mdi-check-circle</v-icon>
                        {{ resultadosProcesados.length }} periodo(s) descargado(s) correctamente.
                    </p>
                    <v-list v-if="resultadosErrores.length > 0" dense class="error-list">
                        <p class="mb-2" style="color:#F57C00; font-weight:600;">
                            <v-icon color="#F57C00" class="mr-1">mdi-alert</v-icon>
                            Los siguientes periodos no pudieron descargarse:
                        </p>
                        <v-list-item
                            v-for="(err, idx) in resultadosErrores"
                            :key="idx"
                            class="error-item mb-1"
                        >
                            <v-list-item-content>
                                <v-list-item-title>
                                    <v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
                                    <strong>{{ err.periodo }}</strong>: {{ err.error }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn elevation="0" class="btnNormalClaro" @click="dialogResultados = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal: Descarga masiva -->
        <v-dialog v-model="dialogDescargaMasiva" max-width="600px" persistent>
            <v-card>
                <v-card-title class="d-flex justify-space-between align-center">
                    <span class="text-h6">Descarga masiva</span>
                    <v-btn icon @click="dialogDescargaMasiva = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pt-4">
                    <v-autocomplete
                        v-if="rol == 'root'"
                        outlined
                        :items="clientes"
                        item-text="nombre"
                        item-value="id"
                        label="Cliente"
                        v-model="clienteMasiva"
                        no-data-text="Datos no disponibles"
                        clearable
                        class="mb-2"
                        @change="onClienteMasivaChange"
                    ></v-autocomplete>

                    <VuetifyMultipleAutocomplete2
                        :outlined="true"
                        :items="itemsRPsMasiva"
                        item_text="nombreClave"
                        item_value="id"
                        label="Registros patronales"
                        :valorDefecto="rpsDescargaMasiva"
                        @dataMultiple="rpsDescargaMasiva = $event"
                        class="mb-2"
                    />

                    <!-- Selector de períodos -->
                    <div class="mb-2">
                        <div class="d-flex align-center mb-1">
                            <v-menu
                                v-model="menuPeriodoMasiva"
                                :close-on-content-click="false"
                                max-width="290px"
                                min-width="290px"
                                offset-y
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-bind="attrs"
                                        v-on="on"
                                        outlined
                                        label="Agregar período"
                                        :value="periodoMasivaTemp ? periodoMesAnio(periodoMasivaTemp) : ''"
                                        readonly
                                        hide-details
                                        append-icon="mdi-calendar"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="periodoMasivaTemp"
                                    type="month"
                                    locale="es"
                                    no-title
                                    color="#2DB9D1"
                                    @input="agregarPeriodoMasiva"
                                ></v-date-picker>
                            </v-menu>
                        </div>
                        <div v-if="periodosDescargaMasiva.length > 0" class="d-flex flex-wrap" style="gap:6px;">
                            <v-chip
                                v-for="p in periodosDescargaMasiva"
                                :key="p"
                                close
                                small
                                color="#E4E4E5"
                                text-color="#444975"
                                @click:close="removerPeriodoMasiva(p)"
                            >{{ periodoMesAnio(p) }}</v-chip>
                        </div>
                        <div v-else class="caption grey--text">Sin períodos seleccionados</div>
                    </div>

                    <p class="subtitle-2 mb-1" style="color:#444975;">Tipo de descarga</p>
                    <v-radio-group v-model="tipoDescargaMasiva" row class="mt-0">
                        <v-radio label="Descargar IMSS" value="masivoIMSS" color="#2DB9D1"></v-radio>
                        <v-radio label="Descargar Archivos" value="masivoArchivos" color="#2DB9D1"></v-radio>
                    </v-radio-group>


                    <p v-if="tipoDescargaMasiva === 'masivoArchivos'" class="subtitle-2 mb-1" style="color:#444975;">Modo de descarga</p>
                    <v-radio-group v-if="tipoDescargaMasiva === 'masivoArchivos'" v-model="modoDescargaMasiva" row class="mt-0">
                        <v-radio label="Por Registro Patronal" value="registro_patronal" color="#2DB9D1"></v-radio>
                        <v-radio label="Por Formato" value="formato" color="#2DB9D1"></v-radio>
                    </v-radio-group>
                </v-card-text>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn elevation="0" class="btnCerrar mr-2" @click="dialogDescargaMasiva = false">
                        Cancelar
                    </v-btn>
                    <v-btn elevation="0" class="btnNormalClaro px-4" @click="confirmarDescargaMasiva()">
                        Descargar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal: Inicializar periodos -->
        <v-dialog v-model="dialogInicializar" max-width="500px" persistent>
            <v-card>
                <v-card-title class="d-flex justify-space-between align-center">
                    <span class="text-h6">Inicializar periodos</span>
                    <v-btn icon @click="dialogInicializar = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <v-radio-group v-model="modoInicializar" class="mt-0">
                        <v-radio label="Año completo" value="anio" color="#2DB9D1"></v-radio>
                        <v-radio label="Periodos específicos" value="periodos" color="#2DB9D1"></v-radio>
                    </v-radio-group>
                    <v-text-field
                        v-if="modoInicializar === 'anio'"
                        v-model.number="anioInicializar"
                        outlined
                        label="Año"
                        type="number"
                        :min="2000"
                        :max="2099"
                    ></v-text-field>
                    <v-combobox
                        v-if="modoInicializar === 'periodos'"
                        v-model="periodosInicializar"
                        outlined
                        label="Periodos (YYYY-MM)"
                        multiple
                        chips
                        small-chips
                        deletable-chips
                        hint="Escribe un período en formato YYYY-MM y presiona Enter"
                        persistent-hint
                    ></v-combobox>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn elevation="0" class="btnCerrar mr-2" @click="dialogInicializar = false">
                        Cancelar
                    </v-btn>
                    <v-btn elevation="0" class="btnNormalClaro" @click="confirmarInicializarPeriodos()">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import BtnAcciones from '@/components/BtnAcciones.vue';
import VuetifyMultipleAutocomplete2 from '@/components/VuetifyMultipleAutocomplete2.vue';
import Notify from '@/plugins/notify';
import clienteApi from '@/api/clientes';
import apiRegistroPatronal from '@/api/nominas/registroPatronal';
import apiEmisiones from '@/api/nominas/emisiones';

export default {
    components: {
        BtnAcciones,
        VuetifyMultipleAutocomplete2,
    },
    computed: {
        totalPages() {
            return Math.max(1, Math.ceil(this.items.length / this.perPage));
        },
        rangoActual() {
            if (this.items.length === 0) return '0 - 0 de 0';
            const from = (this.currentPage - 1) * this.perPage + 1;
            const to = Math.min(this.currentPage * this.perPage, this.items.length);
            return `${from} - ${to} de ${this.items.length}`;
        },
        paginatedItems() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.items.slice(start, start + this.perPage);
        },
        paginasBotones() {
            const total = this.totalPages;
            const current = this.currentPage;
            const pages = [];

            if (total <= 7) {
                for (let i = 1; i <= total; i++) pages.push(i);
            } else if (current <= 4) {
                for (let i = 1; i <= 5; i++) pages.push(i);
                pages.push('...');
                pages.push(total);
            } else if (current >= total - 3) {
                pages.push(1);
                pages.push('...');
                for (let i = total - 4; i <= total; i++) pages.push(i);
            } else {
                pages.push(1);
                pages.push('...');
                pages.push(current - 1);
                pages.push(current);
                pages.push(current + 1);
                pages.push('...');
                pages.push(total);
            }
            return pages;
        },
    },
    data() {
        const now = new Date();
        const anio = now.getFullYear();
        const mes = String(now.getMonth() + 1).padStart(2, '0');

        return {
            overlay         : false,
            fraseOverlay    : 'Procesando...',
            isLoading       : false,
            rol             : null,
            datosLogin      : null,

            clientes                    : [],
            cliente_value               : null,
            itemsRegistrosPatronales    : [],
            registro_patronal_value     : null,

            items               : [],
            selected_general    : [],
            checkAll            : false,
            currentPage         : 1,
            perPage             : 10,
            perPageOptions      : [5, 10, 25, 50, 100],

            dialogResultados    : false,
            resultadosProcesados: [],
            resultadosErrores   : [],

            dialogInicializar       : false,
            modoInicializar         : 'anio',
            anioInicializar         : anio,
            periodosInicializar     : [],

            dialogDescargaMasiva    : false,
            modoDescargaMasiva      : 'registro_patronal',
            tipoDescargaMasiva      : 'masivoIMSS',
            clienteMasiva           : null,
            itemsRPsMasiva          : [],
            rpsDescargaMasiva       : [],
            periodosDescargaMasiva  : [],
            menuPeriodoMasiva       : false,
            periodoMasivaTemp       : null,
        }
    },
    watch: {
        cliente_value(val) {
            this.registro_patronal_value = null;
            this.registros_patronales_value = [];
            this.itemsRegistrosPatronales = [];
            if (val != null) {
                this.getRegistrosPatronales(val);
            }
        },
        registro_patronal_value(val) {
            this.items = [];
            this.resetSeleccion();
        },
        periodo() {
            this.resetSeleccion();
            this.cargarDatos();
        },
    },
    methods: {
        claveUnica(item) {
            return `${item.registro_patronal_id}-${item.periodo}`;
        },
        estaSeleccionado(item) {
            return this.selected_general.includes(this.claveUnica(item));
        },
        selectedItems() {
            return this.items.filter(item => this.selected_general.includes(this.claveUnica(item)));
        },
        toggleSelectAll(val) {
            if (val) {
                this.selected_general = this.items.map(item => this.claveUnica(item));
                this.checkAll = true;
            } else {
                this.selected_general = [];
                this.checkAll = false;
            }
        },
        resetSeleccion() {
            this.selected_general = [];
            this.checkAll = false;
            this.currentPage = 1;
        },
        periodoMesAnio(periodo) {
            if (!periodo) return '';
            const [year, month] = periodo.split('-');
            const meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
                           'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
            return `${meses[parseInt(month) - 1]} ${year}`;
        },
        formatMoney(value) {
            if (value == null) return '$0.00';
            return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);
        },
        async cargarDatos() {
            if (!this.registro_patronal_value) {
                this.items = [];
                return;
            }

            this.isLoading = true;
            try {
                const params = {
                    tipo_consulta: 'consulta',
                    registro_patronal_id: this.registro_patronal_value,
                };

                const response = await apiEmisiones.find(params);
                this.items = response.data || [];
            } catch (error) {
                const msg = error.response?.data?.error || 'Error al cargar las emisiones.';
                Notify.ErrorToast(msg);
            } finally {
                this.isLoading = false;
            }
        },
        async descargarIMSS() {
            const seleccionados = this.selectedItems();
            if (seleccionados.length === 0) {
                Notify.ErrorToast('Debe seleccionar al menos un registro para descargar.');
                return;
            }

            Notify.Alert(
                'ADVERTENCIA',
                'Se descargarán las emisiones seleccionadas desde el IMSS. Esta operación puede tardar varios minutos. ¿Desea continuar?',
                'Descargar',
                async () => {
                    const periodos = seleccionados.map(item => item.periodo);

                    this.overlay = true;
                    this.fraseOverlay = 'Descargando emisiones del IMSS...';

                    try {
                        const response = await apiEmisiones.descargarIMSS({
                            registro_patronal_id: this.registro_patronal_value,
                            periodos,
                        });

                        this.resultadosProcesados = response.data?.procesados || [];
                        this.resultadosErrores = response.data?.errores || [];

                        if (this.resultadosProcesados.length > 0 || this.resultadosErrores.length > 0) {
                            this.dialogResultados = true;
                        }
                    } catch (error) {
                        const msg = error.response?.data?.error || 'Error al descargar las emisiones.';
                        Notify.ErrorToast(msg);
                    } finally {
                        this.overlay = false;
                    }

                    this.resetSeleccion();
                    await this.cargarDatos();
                }
            );
        },
        async descargarArchivo(item, tipo) {
            if (!item.emision_id) {
                Notify.ErrorToast('El archivo no está disponible. Descargue primero la emisión del IMSS.');
                return;
            }
            try {
                const response = await apiEmisiones.descargarArchivo({ emision_id: item.emision_id, tipo });
                const contentDisposition = response.headers['content-disposition'] || '';
                let filename = `${tipo}_${item.registro_patronal}_${item.periodo}.zip`;
                const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match && match[1]) {
                    filename = match[1].replace(/['"]/g, '');
                }
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                const msg = error.response?.data?.error || 'Error al descargar el archivo.';
                Notify.ErrorToast(msg);
            }
        },
        abrirDescargaMasiva() {
            this.rpsDescargaMasiva = [];
            this.periodosDescargaMasiva = [];
            this.tipoDescargaMasiva = 'masivoIMSS';
            this.modoDescargaMasiva = 'registro_patronal';
            this.periodoMasivaTemp = null;
            this.clienteMasiva = null;
            this.itemsRPsMasiva = [];

            if (this.rol !== 'root') {
                this.getRegistrosPatronalesMasiva(this.datosLogin.cliente_id);
            }

            this.dialogDescargaMasiva = true;
        },
        onClienteMasivaChange(val) {
            this.rpsDescargaMasiva = [];
            this.itemsRPsMasiva = [];
            if (val) {
                this.getRegistrosPatronalesMasiva(val);
            }
        },
        async getRegistrosPatronalesMasiva(clienteId) {
            if (clienteId == null) return;
            const params = { activo: true, paginate: false, order: 'asc', cliente_id: clienteId };
            try {
                const response = await apiRegistroPatronal.find(params);
                this.itemsRPsMasiva = (response.data || []).map(item => ({
                    ...item,
                    nombreClave: `${item.nombre} - ${item.clave} - ${item.registro_patronal}`,
                }));
            } catch (error) {
                Notify.ErrorToast('Error al cargar los Registros Patronales.');
            }
        },
        agregarPeriodoMasiva(valor) {
            this.menuPeriodoMasiva = false;
            if (valor && !this.periodosDescargaMasiva.includes(valor)) {
                this.periodosDescargaMasiva.push(valor);
                this.periodosDescargaMasiva.sort();
            }
            this.periodoMasivaTemp = null;
        },
        removerPeriodoMasiva(periodo) {
            this.periodosDescargaMasiva = this.periodosDescargaMasiva.filter(p => p !== periodo);
        },
        async confirmarDescargaMasiva() {
            if (this.rpsDescargaMasiva.length === 0) {
                Notify.ErrorToast('Debe seleccionar al menos un Registro Patronal.');
                return;
            }
            if (this.periodosDescargaMasiva.length === 0) {
                Notify.ErrorToast('Debe seleccionar al menos un período.');
                return;
            }

            this.dialogDescargaMasiva = false;
            this.overlay = true;
            this.fraseOverlay = 'Generando archivo ZIP masivo...';

            try {
                let parametros = {
                    registro_patronal_ids: this.rpsDescargaMasiva,
                    periodos: this.periodosDescargaMasiva,
                    solo_guardar: this.tipoDescargaMasiva === 'masivoArchivos' ? false : true,
                }

                if (this.tipoDescargaMasiva === 'masivoArchivos') {
                    parametros = {
                        ...parametros,
                        modo: this.modoDescargaMasiva
                    }


                    const response = await apiEmisiones.descargaMasiva(parametros, 'blob');
                    const contentDisposition = response.headers['content-disposition'] || '';
                    let filename = 'IDSE_EMISIONES.zip';
                    const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (match && match[1]) {
                        filename = match[1].replace(/['"]/g, '');
                    }
                    const blob = new Blob([response.data], { type: 'application/zip' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }
                else {
                    const response = await apiEmisiones.descargaMasiva(parametros);
                    if (response.data.data?.errores && response.data.data.errores.length > 0) {
                        let leyenda = ``

                        if (typeof response.data.data.errores === 'string') {
                            leyenda = response.data.data.errores // también era un typo aquí
                        } else {
                            response.data.data.errores.forEach((el) => {
                                leyenda += `* ${el.registro_patronal} - ${el.periodo} - ${el.error}<br>`
                            })
                        }

                        Notify.ErrorToast(leyenda);
                    }
                }
                this.cargarDatos()
                
            } catch (error) {
                const msg = error.response?.data?.error || 'Error al generar la descarga masiva.';
                Notify.ErrorToast(msg);
            } finally {
                this.overlay = false;
            }
        },
        abrirInicializarPeriodos() {
            const now = new Date();
            this.modoInicializar = 'anio';
            this.anioInicializar = now.getFullYear();
            this.periodosInicializar = [];
            this.dialogInicializar = true;
        },
        async confirmarInicializarPeriodos() {
            if (!this.registro_patronal_value) {
                Notify.ErrorToast('Debe seleccionar un registro patronal.');
                return;
            }
            if (this.modoInicializar === 'anio' && !this.anioInicializar) {
                Notify.ErrorToast('Debe indicar un año.');
                return;
            }
            if (this.modoInicializar === 'periodos' && (!this.periodosInicializar || this.periodosInicializar.length === 0)) {
                Notify.ErrorToast('Debe indicar al menos un período.');
                return;
            }

            const params = { registro_patronal_id: this.registro_patronal_value };
            if (this.modoInicializar === 'anio') {
                params.anio = this.anioInicializar;
            } else {
                params.periodos = this.periodosInicializar;
            }

            this.overlay = true;
            this.fraseOverlay = 'Inicializando periodos...';

            try {
                const response = await apiEmisiones.inicializarPeriodos(params);
                Notify.SuccessToast(response.message || 'Periodos inicializados correctamente.');
                this.dialogInicializar = false;
                await this.cargarDatos();
            } catch (error) {
                const msg = error.response?.data?.error || 'Error al inicializar los periodos.';
                Notify.ErrorToast(msg);
            } finally {
                this.overlay = false;
            }
        },
        async getRegistrosPatronales(clienteId) {
            if (clienteId == null) return;
            this.itemsRegistrosPatronales = [];
            const params = { activo: true, paginate: false, order: 'asc', cliente_id: clienteId };
            try {
                const response = await apiRegistroPatronal.find(params);
                this.itemsRegistrosPatronales = (response.data || []).map(item => ({
                    ...item,
                    nombreClave: `${item.nombre} - ${item.clave} - ${item.registro_patronal}`,
                }));
            } catch (error) {
                Notify.ErrorToast('Error al cargar los Registros Patronales.');
            }
        },
        async getClientes() {
            try {
                const response = await clienteApi.getClientes({ activo: true, paginate: false });
                this.clientes = response.data || response;
            } catch (error) {
                Notify.ErrorToast('Error al cargar los clientes.');
            }
        },
        refresh() {
            this.items = [];
            this.resetSeleccion();

            if (this.rol === 'root') {
                this.cliente_value = null;
                this.getClientes();
            }

            this.registro_patronal_value = null;
        },
    },
    created() {
        this.datosLogin = this.$session.get('usuario');
        this.rol = this.datosLogin.rol.name;

        if (this.rol === 'root') {
            this.getClientes();
        } else {
            this.cliente_value = this.datosLogin.cliente_id;
        }
    },
}
</script>

<style scoped>
    .div-card {
        background-color: #fdfcfc;
        border-radius: 20px;
    }
    .btn-afiliacion {
        background-color: #E4E4E5;
        height: 2.1875rem;
        border-radius: 8px;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        cursor: pointer;
    }
    .btn-activo {
        color: #444975;
    }
    .btn-inactivo {
        color: #828282;
    }

    /* Tabla */
    .table-wrapper {
        overflow-x: auto;
    }
    .emisiones-table {
        width: 100%;
        border-collapse: collapse;
        font-family: 'Montserrat';
        font-size: 13px;
    }
    .emisiones-table thead tr {
        border-bottom: 2px solid #E4E4E5;
    }
    .emisiones-table th {
        padding: 10px 12px;
        font-weight: 600;
        color: #444975;
        text-align: left;
        white-space: nowrap;
        background-color: #fdfcfc;
    }
    .emisiones-table th.th-center,
    .emisiones-table td.td-center {
        text-align: center;
    }
    .emisiones-table th.th-right,
    .emisiones-table td.td-right {
        text-align: right;
    }
    .th-check, .td-check {
        width: 60px;
        text-align: center;
    }
    .emisiones-table tbody tr {
        border-bottom: 1px solid #F0F0F0;
        transition: background 0.15s;
    }
    .emisiones-table tbody tr:hover {
        background-color: #F8FAFB;
    }
    .emisiones-table td {
        padding: 10px 12px;
        color: #4F4F4F;
    }
    .row-selected {
        background-color: #EAF7FA !important;
    }
    .td-periodo {
        font-weight: 500;
        color: #444975;
    }

    /* Links de archivos */
    .link-activo {
        color: #2DB9D1;
        font-weight: 600;
        cursor: pointer;
        text-decoration: underline;
    }
    .link-activo:hover {
        color: #1a9cb8;
    }
    .link-inactivo {
        color: #BDBDBD;
        cursor: default;
        text-decoration: none;
    }
    .link-excel {
        color: #27AE60;
        font-weight: 600;
        cursor: pointer;
        text-decoration: underline;
    }
    .link-excel:hover {
        color: #1e8a4c;
    }
    .link-sep {
        color: #BDBDBD;
        margin: 0 4px;
    }

    /* Paginación */
    .pagination-row {
        flex-wrap: wrap;
        gap: 2px;
    }
    .pagination-label {
        font-family: 'Montserrat';
        font-size: 13px;
        color: #4F4F4F;
        white-space: nowrap;
    }
    .per-page-select {
        max-width: 75px;
        font-size: 13px;
    }
    .pagination-range {
        font-family: 'Montserrat';
        font-size: 13px;
        color: #4F4F4F;
        white-space: nowrap;
    }
    .pagination-ellipsis {
        font-family: 'Montserrat';
        font-size: 13px;
        color: #4F4F4F;
        padding: 0 4px;
        line-height: 28px;
    }
    .pagination-page-btn {
        font-family: 'Montserrat';
        font-size: 13px;
    }
    .pagination-btn-active {
        color: #444975 !important;
        font-weight: 700;
        background-color: #E4E4E5 !important;
        border-radius: 6px;
    }
    .pagination-btn {
        color: #828282;
    }

    /* Mensajes */
    .text-no-elementos {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 37px;
        color: #828282;
    }

    /* Acciones dropdown */
    div.btnAccionesItem {
        width: 100%;
        cursor: pointer;
        outline: 0;
        padding-left: 30px;
        padding-right: 30px;
    }
    div.btnAccionesItem span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
        color: #828282;
    }
    div.btnAccionesItem:hover {
        background: #F6F6F8;
    }
    .deshabilitado {
        background: #fcf6f6;
        cursor: not-allowed !important;
    }
    div.deshabilitado span {
        color: #c0c0c0;
    }

    /* Modal errores */
    .error-list {
        max-height: 300px;
        overflow-y: auto;
        border-radius: 8px;
    }
    .error-item {
        background-color: #fff;
        border-left: 3px solid #F44336;
        border-radius: 4px;
        padding: 6px 8px;
    }
</style>
